module.exports = __webpack_public_path__ + "static/media/fpmccann white.1fa86107.png";